import React, { useContext } from 'react';

import CardControlContext from '@/context/card-control/CardControlContext';
import { useCardSpendingLimits } from '@/react-query/hooks/query/use-spending-limits';

import BackButton from '@components/back-button/BackButton';
import { prettyCategoryName } from '@components/card-control/functions';
import { SpendingLimitCategory } from '@components/card-control/types';
import { MonetaryAmount } from '@generated-types';
import useText from '@hooks/use-text';
import { prettyMonetary } from '@utils/text-format-utils';

import './ReadOnly.scss';

interface ReadOnlyProps {
    category: SpendingLimitCategory;
    value: MonetaryAmount | undefined;
}

const ReadOnly = ({ category, value }: ReadOnlyProps) => {
    const text = useText();
    const { removeSelectedCategory } = useContext(CardControlContext);

    return (
        <div className="spending-limits__category__read-only">
            <dl>
                <dt className="spending-limits__category__read-only__category">{prettyCategoryName(category, text)}</dt>
                <dd className="spending-limits__category__read-only__value">
                    {value ? prettyMonetary(value) : text.spendingLimitsNoLimit}
                </dd>
            </dl>
            <BackButton onClick={() => removeSelectedCategory()} />
        </div>
    );
};

export const DailyLimitReadOnly = () => {
    const { data: spendingLimits } = useCardSpendingLimits();

    return <ReadOnly category={SpendingLimitCategory.DailyLimit} value={spendingLimits?.card?.daily} />;
};

export const MonthlyLimitReadOnly = () => {
    const { data: spendingLimits } = useCardSpendingLimits();

    return <ReadOnly category={SpendingLimitCategory.MonthlyLimit} value={spendingLimits?.card?.monthly} />;
};

export const DailyLimitEcommerceReadOnly = () => {
    const { data: spendingLimits } = useCardSpendingLimits();

    return <ReadOnly category={SpendingLimitCategory.DailyLimitEcommerce} value={spendingLimits?.app?.daily} />;
};

export const MonthlyLimitEcommerceReadOnly = () => {
    const { data: spendingLimits } = useCardSpendingLimits();

    return <ReadOnly category={SpendingLimitCategory.MonthlyLimitEcommerce} value={spendingLimits?.app?.monthly} />;
};
